
import clsx from 'clsx';
import { Anchor, Störer, OrDivider } from 'components/atoms';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { PremiumInfoDto } from 'types';
import { useAboIntent, useTranslation, useUserTier } from 'utils/hooks';
import useDirektkauf from 'utils/hooks/state/useDirektkauf';
import type { TranslationKey } from 'utils/hooks/useTranslation';

import css from './PlusTeaser.module.scss';

interface PlusRowProps
{
  fakeContent: React.ReactNode | React.ReactNode[];
  plusInhalte: PremiumInfoDto;
}

const PlusRow: React.FC<PlusRowProps> = ({ fakeContent, plusInhalte }) =>
{
  const { r, t } = useTranslation('profiles');

  const tier = useUserTier();
  const [, setDirektkauf] = useDirektkauf();
  const router = useRouter();
  const [, setAboIntent] = useAboIntent();

  const isUnternehmenUrl = router.pathname.startsWith('/u/');
  const title = isUnternehmenUrl ? t('profiles:plusTeaser.titleUnternehmen') : t('profiles:plusTeaser.titlePerson');

  const perks = () =>
  {
    const list = [t('profiles:plusTeaser.list.historischeDaten'), t('profiles:plusTeaser.list.änderungsliste')];
    Object.entries(plusInhalte).forEach(([key, value]) =>
    {
      if (typeof value === 'number' && value > 0)
      {
        list.push(`${t(`profiles:plusTeaser.list.${key}` as TranslationKey)} (${t('formats:number', { value })})`);
      }
      else if (typeof value === 'boolean' && value)
      {
        list.push(`${t(`profiles:plusTeaser.list.${key}` as TranslationKey)}`);
      }
    });
    return (
      <ul className={clsx({ [css.columns]: list.length > 2 })}>
        {list.map((item) => <li key={item}>{item}</li>)}
      </ul>);
  };


  return (
    <div id="plus-inhalte" className={css.container}>
      <div className={css.fake}>
        {fakeContent}
      </div>
      <div className={css.content}>
        <h2>{title}</h2>
        <p>{r('profiles:plusTeaser.description')}</p>
        {perks()}
        <hr/>

        <div className={css.actions}>

          <Link legacyBehavior href={`/user/${tier == 'free' ? 'register' : 'upgrade'}`} passHref prefetch={false}>
            <a className={clsx(css.action, css.abo)} onClick={()=>
            {
              if (tier === 'free')
              {
                setAboIntent();
              }
            }}>
              {r('profiles:plusTeaser.aboCta')}
              <div className={css.störerContainer}>
                <Störer>
                  <span>
                    {r('profiles:plusTeaser.aboStörer', { price: <span className={css.price}/> })}
                  </span>
                </Störer>
              </div>
            </a>
          </Link>

          <button className={clsx(css.action, css.direkt)} onClick={() => setDirektkauf('info')}>
            {r('profiles:plusTeaser.direktkaufCta')}
            <div className={css.störerContainer}>
              <Störer>
                <span>
                 {r('profiles:plusTeaser.direktkaufStörer', { price: <span className={css.price}/> })}
                </span>
              </Störer>
            </div>
          </button>

        </div>

        {tier == 'free' && <div className={css.registerContainer}>
            <OrDivider />
            <p>{r('profiles:plusTeaser.freeDescription')}</p>
            <Anchor href="/user/register" as='button'>{t('profiles:plusTeaser.freeRegister')}</Anchor>
        </div>}
      </div>
    </div>

  );
};

export default PlusRow;
